module.exports = __webpack_public_path__ + "7b0636dc.svg";